{
  "name": "tessera-ui",
  "version": "1.3.0",
  "private": true,
  "packageManager": "npm@11.7.0",
  "type": "module",
  "engines": {
    "node": ">=24.0.0"
  },
  "scripts": {
    "predev": "tsx scripts/validate-env.ts && turbo run i18n:compile",
    "dev": "vite dev",
    "predev:inspect": "tsx scripts/validate-env.ts && turbo run i18n:compile",
    "dev:inspect": "VITE_ENABLE_DEVTOOLS=true vite dev",
    "prebuild": "tsx scripts/validate-env.ts && turbo run i18n:compile",
    "build": "NODE_OPTIONS=--max-old-space-size=4096 vite build",
    "prebuild:analyze": "tsx scripts/validate-env.ts && turbo run i18n:compile",
    "build:analyze": "ANALYZE=true NODE_OPTIONS=--max-old-space-size=4096 vite build",
    "build:turbo": "turbo run build",
    "start": "node --env-file=.env --import tsx/esm --import ./src/instrumentation.ts .output/server/index.mjs",
    "preview": "npm run build && npm run start",
    "lint": "oxlint .",
    "lint:strict": "oxlint . --max-warnings 0",
    "lint:fix": "node scripts/oxlint-fix.mjs",
    "i18n:extract": "formatjs extract \"src/**/*.{ts,tsx}\" --format simple --out-file src/i18n/messages/extracted/en-US.json --ignore \"**/__tests__/**\" --ignore \"src/i18n/messages/*.ts\" --ignore \"**/*.d.ts\"",
    "i18n:compile": "node scripts/build-i18n.mjs",
    "i18n": "turbo run i18n:compile",
    "test": "vitest run --reporter=dot",
    "test:verbose": "vitest run --reporter=verbose",
    "test:watch": "vitest --reporter=dot",
    "test:ui": "vitest --ui",
    "test:coverage": "vitest run --coverage --reporter=dot",
    "test:silent": "vitest run --reporter=basic",
    "test:e2e": "playwright test",
    "test:e2e:ui": "playwright test --ui",
    "test:smoke": "playwright test e2e/smoke.spec.ts",
    "prepare": "husky",
    "type-check": "tsc --noEmit",
    "typecheck": "tsc --noEmit",
    "nuke": "rm -rf node_modules dist .output .turbo .next .orval-cache",
    "nuke:gen": "rm -rf src/api/gen .orval-cache",
    "storybook": "storybook dev -p 6006",
    "build-storybook": "storybook build",
    "codegen:api": "NODE_NO_WARNINGS=1 dotenv -e .env -- tsx scripts/codegen.ts",
    "codegen:api:skip-cache": "NODE_NO_WARNINGS=1 dotenv -e .env -- tsx scripts/codegen.ts --skip-cache",
    "codegen:api:force": "NODE_NO_WARNINGS=1 dotenv -e .env -- tsx scripts/codegen.ts --force",
    "codegen:api:watch": "NODE_NO_WARNINGS=1 dotenv -e .env -- orval --watch",
    "codegen:docs": "tsx scripts/gen-docs-tree.ts",
    "codegen:abap-keywords": "node scripts/generate-abap-keywords.mjs",
    "check:slice-docs": "tsx scripts/check-slice-doc-sync.ts",
    "validate": "turbo run lint type-check test"
  },
  "lint-staged": {
    "*.{ts,tsx,js,jsx}": [
      "node scripts/oxlint-fix.mjs"
    ]
  },
  "overrides": {
    "brace-expansion": "^5.0.8",
    "gaxios": "^7.3.0",
    "fast-xml-parser": "^5.4.1",
    "hono": "^4.13.0",
    "qs": "^6.15.0",
    "esbuild": ">=0.28.1",
    "js-yaml": "^4.3.1",
    "rollup": "^4.59.0",
    "@scalar/openapi-parser": "0.25.3",
    "fast-uri": "^3.1.5",
    "linkify-it": "^5.0.2",
    "@opentelemetry/propagator-jaeger": "^2.10.0",
    "ip-address": "^10.2.2",
    "undici": "^7.29.0",
    "@tanstack/eslint-plugin-query": {
      "typescript": "$typescript"
    }
  },
  "dependencies": {
    "@base-ui/react": "1.1.0",
    "@codemirror/autocomplete": "^6.20.0",
    "@codemirror/commands": "^6.10.1",
    "@codemirror/lang-python": "^6.2.1",
    "@codemirror/lang-sql": "^6.10.0",
    "@codemirror/language": "^6.12.1",
    "@codemirror/lint": "^6.9.2",
    "@codemirror/merge": "^6.11.2",
    "@codemirror/search": "^6.6.0",
    "@codemirror/state": "^6.5.4",
    "@codemirror/theme-one-dark": "^6.1.3",
    "@codemirror/view": "^6.39.11",
    "@dagrejs/dagre": "^3.0.0",
    "@dnd-kit/core": "^6.3.1",
    "@dnd-kit/react": "^0.3.2",
    "@hookform/resolvers": "^5.2.1",
    "@lezer/common": "^1.5.2",
    "@lezer/highlight": "^1.2.3",
    "@opentelemetry/api": "^1.9.0",
    "@opentelemetry/auto-instrumentations-node": "^0.78.0",
    "@opentelemetry/exporter-trace-otlp-grpc": "^0.219.0",
    "@opentelemetry/sdk-node": "^0.221.0",
    "@opentelemetry/semantic-conventions": "^1.41.1",
    "@orama/orama": "^3.1.18",
    "@polyglot-sql/sdk": "^0.6.2",
    "@radix-ui/react-alert-dialog": "^1.1.4",
    "@radix-ui/react-dialog": "^1.1.2",
    "@radix-ui/react-dropdown-menu": "^2.1.4",
    "@radix-ui/react-popover": "^1.1.6",
    "@radix-ui/react-scroll-area": "^1.2.0",
    "@radix-ui/react-select": "^2.1.4",
    "@radix-ui/react-separator": "^1.1.7",
    "@radix-ui/react-slot": "^1.1.0",
    "@radix-ui/react-tabs": "^1.1.2",
    "@radix-ui/react-tooltip": "^1.2.6",
    "@react-hookz/web": "^26.1.0",
    "@tailwindcss/typography": "^0.5.15",
    "@tanstack/react-hotkeys": "0.10.0",
    "@tanstack/react-query": "^5.90.21",
    "@tanstack/react-query-devtools": "^5.91.3",
    "@tanstack/react-router": "^1.170.10",
    "@tanstack/react-router-devtools": "^1.167.0",
    "@tanstack/react-router-ssr-query": "^1.167.1",
    "@tanstack/react-start": "^1.168.18",
    "@tanstack/react-table": "^8.21.3",
    "@tanstack/react-virtual": "^3.13.18",
    "@tessera-labs-inc/abaplint-core": "^1.9.0",
    "@uiw/codemirror-theme-eclipse": "^4.25.4",
    "@uiw/codemirror-theme-nord": "^4.25.4",
    "@uiw/codemirror-theme-sublime": "^4.25.4",
    "@uiw/codemirror-theme-vscode": "^4.25.4",
    "@uiw/react-codemirror": "^4.25.4",
    "@xyflow/react": "^12.8.3",
    "axios": "^1.15.2",
    "canvas-confetti": "^1.9.4",
    "class-variance-authority": "^0.7.1",
    "clsx": "^2.1.1",
    "cmdk": "^1.1.1",
    "codemirror-json-schema": "^0.8.1",
    "cookie-es": "^3.1.1",
    "cronstrue": "^3.24.0",
    "d3-force": "^3.0.0",
    "date-fns": "^4.1.0",
    "diff": "^9.0.0",
    "es-toolkit": "^1.46.1",
    "form-data": "^4.0.3",
    "fuse.js": "^7.1.0",
    "humanize-string": "^3.0.0",
    "keycloak-js": "^26.1.3",
    "lodash": "^4.18.1",
    "lucide-react": "^1.7.0",
    "motion": "^12.26.2",
    "p-limit": "^7.3.0",
    "papaparse": "^5.5.3",
    "pdfjs-dist": "^6.1.200",
    "react": "^19.2.3",
    "react-day-picker": "^10.0.1",
    "react-dom": "^19.2.3",
    "react-force-graph-3d": "^1.29.1",
    "react-hook-form": "^7.62.0",
    "react-icons": "^5.5.0",
    "react-intl": "^10.1.4",
    "react-resizable-panels": "^4.2.0",
    "recharts": "^2.8.0",
    "shiki": "^4.0.1",
    "sonner": "^2.0.7",
    "sql-formatter": "^15.7.3",
    "streamdown": "^2.0.1",
    "tailwind-merge": "^3.6.0",
    "three-spritetext": "^1.10.0",
    "tw-animate-css": "^1.4.0",
    "type-fest": "^4.40.1",
    "uuid": "^14.0.0",
    "write-excel-file": "^4.1.1",
    "yaml": "^2.8.3",
    "zod": "^4.4.3",
    "zustand": "^5.0.4"
  },
  "devDependencies": {
    "@formatjs/cli": "^6.10.0",
    "@mdx-js/react": "^3.1.1",
    "@mdx-js/rollup": "^3.1.1",
    "@playwright/test": "^1.57.0",
    "@secretlint/secretlint-rule-preset-recommend": "^13.0.4",
    "@storybook/addon-a11y": "^10.4.4",
    "@storybook/addon-docs": "^10.4.4",
    "@storybook/react-vite": "^10.4.4",
    "@stylistic/eslint-plugin": "^5.10.0",
    "@tailwindcss/vite": "^4.2.2",
    "@tanstack/devtools-vite": "^0.6.0",
    "@tanstack/eslint-plugin-query": "^5.91.4",
    "@tanstack/react-devtools": "^0.9.6",
    "@testing-library/jest-dom": "^6.6.3",
    "@testing-library/react": "^16.1.0",
    "@testing-library/user-event": "^14.5.2",
    "@types/canvas-confetti": "^1.9.0",
    "@types/d3-force": "^3.0.10",
    "@types/dagre": "^0.7.53",
    "@types/lodash": "^4.17.16",
    "@types/mdx": "^2.0.14",
    "@types/node": "^25.6.0",
    "@types/papaparse": "^5.5.1",
    "@types/react": "^19.2.7",
    "@types/react-dom": "^19.2.3",
    "@types/three": "^0.185.4",
    "@vitejs/plugin-react": "^5.2.0",
    "@vitest/coverage-v8": "^4.1.5",
    "babel-plugin-react-compiler": "^1.0.0",
    "dotenv-cli": "^11.0.0",
    "eslint": "^10.3.0",
    "eslint-plugin-prettier": "^5.5.4",
    "eslint-plugin-simple-import-sort": "^13.0.0",
    "eslint-plugin-turbo": "^2.7.2",
    "husky": "^9.1.7",
    "jsdom": "^30.0.1",
    "lint-staged": "^16.4.0",
    "nitro": "^3.0.260429-beta",
    "orval": "^8.17.0",
    "oxlint": "^1.77.0",
    "postcss": "^8.5.23",
    "prettier": "^3.7.4",
    "rehype-slug": "^6.0.0",
    "remark-frontmatter": "^5.0.0",
    "rollup-plugin-visualizer": "^7.0.1",
    "secretlint": "^13.0.4",
    "shadcn": "^4.0.8",
    "storybook": "^10.4.4",
    "tailwindcss": "^4.1.18",
    "tsx": "^4.22.4",
    "turbo": "^2.9.14",
    "typescript": "^7.0.2",
    "vite": "^8.0.16",
    "vite-plugin-svgr": "^5.2.0",
    "vitest": "^4.1.1"
  },
  "allowScripts": {
    "esbuild@0.28.1": true,
    "fsevents@2.3.3": true,
    "fsevents@2.3.2": true,
    "protobufjs@7.6.5": true
  }
}
